/* eslint-disable react-hooks/exhaustive-deps */
// export default IncidentRequest;
import CloseInvestigationFile from "components/CoseInvestigationFile";
import Loading from "components/Loading";
import RequestDoubtful from "components/RequestDoubtful";
import RequestInstituteOfCharge from "components/RequestInsituteOfCharge";
import PettyOffeneRequest from "components/RequestPettyOffence";
import RequestSuspectToWitnessModal from "components/RequestSuspecToWitness";
import { useAuth } from "context/AuthContext";
import { useTooltip } from "context/TooltipProvider";
import FurtherInvestigationForm from "pages/InvestigationFileDetail/modal/FurtherInvestigationForm";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { FaBriefcase } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import {
  fetchFurtherInvestigationByCRNumberAndIncidentRegNo,
  fetchReceivingInvestigationFilePaginated,
  fetchReceivingInvestigationFileByCoordinatorPaginated,
  fetchReceivingInvestigationFileByCoordinatorWithTypePaginated,
  fetchReceivingInvestigationFileByPolicePaginated,
  fetchReceivingInvestigationFileByProsecutorPaginated,
} from "services/prosecutorPoliceService";
import {
  FurtherInvestigationDecision,
  InvestigationFile,
  InvestigationFileBy,
  InvestigationFileStatus,
  ProsecutorDecisionType,
  Roles,
} from "types";
import { actionListIcon, eyeIcon, ITEMS_PER_PAGE } from "utils/constant";
import { DateView, errorHandler, hasRole } from "utils/helper";
import PageHeader from "../../components/PageHeader";
import InvestigationFileForm from "./modal/InvestigationFileForm";

const InvestigationFileList: React.FC = () => {
  const { t } = useTranslation();
  const { loginData } = useAuth();
  const { showTooltip } = useTooltip();
  const menuRef = useRef<HTMLDivElement | null>(null);

  const [activeTab, setActiveTab] = useState(t("all"));
  // Server-side filter by prosecutor decision (key → query params).
  const [decisionFilter, setDecisionFilter] = useState("");
  const groupDecision = t("by_decision", { defaultValue: "By Decision" });
  const groupStatus = t("by_status", { defaultValue: "By Status" });
  const decisionFilterOptions: {
    key: string;
    label: string;
    group?: string;
    params: {
      prosecutor_decision?: string;
      prosecutor_decision_status?: string;
      is_re_intiated?: boolean;
    };
  }[] = [
    { key: "", label: t("all_decisions", { defaultValue: "All Decisions" }), params: {} },
    // Record-based: which decision the file has (?prosecutor_decision=).
    {
      key: "private_prosecution",
      group: groupDecision,
      label: t("private_prosecution"),
      params: { prosecutor_decision: "private_prosecution" },
    },
    {
      key: "doubtful",
      group: groupDecision,
      label: t("doubtful"),
      params: { prosecutor_decision: "doubtful" },
    },
    {
      key: "further_investigation",
      group: groupDecision,
      label: t("further_investigation"),
      params: { prosecutor_decision: "further_investigation" },
    },
    {
      key: "institute_charge",
      group: groupDecision,
      label: t("institute_charge"),
      params: { prosecutor_decision: "institute_charge" },
    },
    {
      key: "doesnt_institute_charge",
      group: groupDecision,
      label: t("doesnt_institute_charge"),
      params: { prosecutor_decision: "doesnt_institute_charge" },
    },
    {
      key: "suspect_to_witness",
      group: groupDecision,
      label: t("suspect_to_witness_tab"),
      params: { prosecutor_decision: "suspect_to_witness" },
    },
    {
      key: "suspend",
      group: groupDecision,
      label: t("suspend"),
      params: { prosecutor_decision: "suspend" },
    },
    // Decision approval status (?prosecutor_decision_status=).
    {
      key: "pending",
      group: groupStatus,
      label: t("pending_decisions", { defaultValue: "Pending Decisions" }),
      params: { prosecutor_decision_status: "pending" },
    },
    {
      key: "approved",
      group: groupStatus,
      label: t("approved_decisions", { defaultValue: "Approved Decisions" }),
      params: { prosecutor_decision_status: "approved" },
    },
    {
      key: "revised",
      group: groupStatus,
      label: t("responded_back_decisions", { defaultValue: "Responded Back" }),
      params: { prosecutor_decision_status: "revised" },
    },
    {
      key: "re_initiated",
      group: groupStatus,
      label: t("re_initiated", { defaultValue: "Re-initiated" }),
      params: { is_re_intiated: true },
    },
  ];
  const statusFilters = [
    "forward_to_coordinator",
    "assigned_to_prosecutor",
    "assigned_to_clerk",
    "terminated",
    "further_investigation_requested",
  ];
  const statusDisplayNames: { [key: string]: string } = {
    forward_to_coordinator: "Pending",
    assigned_to_prosecutor: "Assign to Prosecutor",
    assigned_to_clerk: "Forward to Clerk",
    terminated: "Terminated",
    further_investigation_requested: "Further Investigation",
  };

  const isClerk = hasRole(loginData?.roles, [Roles.clerk]);
  const isVariousClerk = hasRole(loginData?.roles, [Roles.variousClerk]);
  const isEconomicClerk = hasRole(loginData?.roles, [Roles.economicClerk]);
  const isCorruptionClerk = hasRole(loginData?.roles, [Roles.corruptionClerk]);
  const isChildClerk = hasRole(loginData?.roles, [Roles.childWomenClerk]);

  const isProsecutor = hasRole(loginData?.roles, [Roles.prosecutor]);
  const isCoordinator = hasRole(loginData?.roles, [
    Roles.coordinator,
    Roles.economicCoordinator,
    Roles.corruptionCoordinator,
    Roles.variousCoordinator,
  ]);
  const isVarious = hasRole(loginData?.roles, [
    Roles.variousCoordinator,
    Roles.variousDirector,
    Roles.variousRegistrar,
  ]);
  const isEconomic = hasRole(loginData?.roles, [
    Roles.economicCoordinator,
    Roles.economicDirector,
    Roles.economicRegistrar,
  ]);
  const isCorruption = hasRole(loginData?.roles, [
    Roles.corruptionCoordinator,
    Roles.corruptionDirector,
    Roles.corruptionRegistrar,
  ]);

  const isChildWomen = hasRole(loginData?.roles, [Roles.childWomenCoordinator]);

  const isZonalVariousChildClerk = hasRole(loginData?.roles, [
    Roles.zonalVariousChildWomenClerk,
  ]);
  const isZonalEconomicCorruptionClerk = hasRole(loginData?.roles, [
    Roles.zonalEconomicCoruptionClerk,
  ]);
  const isZonalVariousChildRegistrar = hasRole(loginData?.roles, [
    Roles.zonalVariousChildWomenRegistrar,
  ]);
  const isZonalEconomicCorruptionRegistrar = hasRole(loginData?.roles, [
    Roles.zonalEconomicCoruptionRegistrsrar,
  ]);

  // Crime-type case registrars. NOTE: the Roles enum keys for these are
  // swapped in types.ts, so match by the literal role value to avoid mapping
  // them to the wrong crime type.
  const isVariousRegistrar = hasRole(loginData?.roles, ["CaseVariousRegistrar"]);
  const isCorruptionRegistrar = hasRole(loginData?.roles, [
    "CaseCorruptionRegistrar",
  ]);
  const isEconomicRegistrar = hasRole(loginData?.roles, [
    "CaseEconomicRegistrar",
  ]);

  // Show status filters only for coordinator roles
  const showStatusFilters =
    isCoordinator || isVarious || isEconomic || isCorruption;
  const tabs = showStatusFilters
    ? [
        t("all"),
        ...statusFilters.map(
          (status) => statusDisplayNames[status] || t(status),
        ),
      ]
    : [t("all")];

  const [investigationFiles, setInvestigationFiles] = useState<
    InvestigationFile[]
  >([]);
  // fileId -> latest further-investigation decision (fetched per page).
  const [fiDecisions, setFiDecisions] = useState<Record<string, string>>({});
  const [loading, setLoading] = useState(true);
  const [action, setAction] = useState<"Add" | "Edit">("Add");
  const [fileTooltip, setFileTooltip] = React.useState<InvestigationFile>();
  const [selectedFile, setSelectedFile] = React.useState<InvestigationFile>();
  const [isOpenForm, setIsOpenForm] = React.useState(false);
  const [isOpenInstituteOfCharge, setIsOpenInstituteOfCharge] =
    React.useState(false);
  const [isOpenClosed, setIsOpenClosed] = React.useState(false);
  const [isOpenPettyOffence, setIsOpenPettyOffence] = React.useState(false);
  const [isOpenFurtherInvestigation, setIsOpenFurtherInvestigation] =
    React.useState(false);

  const [isOpenDoubtful, setIsOpenDoubtful] = React.useState(false);
  const [isOpenSuspectToWitess, setIsOpenSuspectToWitness] =
    React.useState(false);

  const [search, setSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [count, setCount] = useState(0);
  const navigate = useNavigate();

  // Clerks only ever see files assigned to them — enforced server-side.
  const clerkOnlyAssigned =
    isVariousClerk || isEconomicClerk || isCorruptionClerk;

  // Map the active tab (display name) to the backend `status` value.
  const statusParam = clerkOnlyAssigned
    ? "assigned_to_clerk"
    : activeTab !== t("all")
      ? Object.keys(statusDisplayNames).find(
          (key) => statusDisplayNames[key] === activeTab,
        )
      : undefined;

  const fetchData = (page = currentPage) => {
    setLoading(true);
    const adminUnit = loginData?.admin_unit || "";
    const orgUnit = loginData?.org_unit || "";
    const decisionParams =
      decisionFilterOptions.find((o) => o.key === decisionFilter)?.params || {};
    const params = {
      page,
      pageSize: ITEMS_PER_PAGE,
      search: debouncedSearch || undefined,
      status: statusParam || undefined,
      ...decisionParams,
    };

    const byType = (role: string) =>
      fetchReceivingInvestigationFileByCoordinatorWithTypePaginated(
        adminUnit,
        role,
        params,
      );

    const api =
      isZonalVariousChildRegistrar || isZonalEconomicCorruptionRegistrar
        ? byType(
            isZonalVariousChildRegistrar
              ? Roles.zonalVariousChildWomenRegistrar
              : Roles.zonalEconomicCoruptionRegistrsrar,
          )
        : isVariousRegistrar
          ? byType(Roles.variousCoordinator)
          : isCorruptionRegistrar
            ? byType(Roles.corruptionCoordinator)
            : isEconomicRegistrar
              ? byType(Roles.economicCoordinator)
              : isClerk
          ? isZonalEconomicCorruptionClerk || isZonalVariousChildClerk
            ? byType(
                isZonalEconomicCorruptionClerk
                  ? Roles.zonalEconomicCoruptionClerk
                  : Roles.zonalVariousChildWomenClerk,
              )
            : isChildClerk
              ? byType(Roles.childWomenClerk)
              : byType(
                  isVariousClerk
                    ? Roles.variousClerk
                    : isEconomicClerk
                      ? Roles.economicClerk
                      : Roles.corruptionClerk,
                )
          : isVarious
            ? byType(Roles.variousCoordinator)
            : isEconomic
              ? byType(Roles.economicCoordinator)
              : isCorruption
                ? byType(Roles.corruptionCoordinator)
                : isChildWomen
                  ? byType(Roles.childWomenCoordinator)
                  : isCoordinator
                    ? fetchReceivingInvestigationFileByCoordinatorPaginated(
                        adminUnit,
                        orgUnit,
                        params,
                      )
                    : isProsecutor
                      ? fetchReceivingInvestigationFileByProsecutorPaginated(
                          loginData?.user_id || "",
                          params,
                        )
                      : loginData?.is_police || loginData?.role === "Member"
                        ? fetchReceivingInvestigationFileByPolicePaginated(
                            loginData?.organization?.uu_id || "",
                            params,
                          )
                        : fetchReceivingInvestigationFilePaginated(params);
    api
      .then((data) => {
        setInvestigationFiles(data.results);
        setCount(data.count);
        setLoading(false);
      })
      .catch((error) => {
        error?.response?.data?.message !==
          "No investigation files found for this police station." &&
          showTooltip(errorHandler(error));
        setInvestigationFiles([]);
        setCount(0);
        setLoading(false);
      });
  };

  // Debounce the search box; reset to the first page on a new term.
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(search.trim());
      setCurrentPage(1);
    }, 400);
    return () => clearTimeout(timer);
  }, [search]);

  // Refetch whenever the page, search term, active tab, or decision filter changes.
  useEffect(() => {
    if (loginData) fetchData(currentPage);
  }, [loginData, currentPage, debouncedSearch, activeTab, decisionFilter]);

  // For files in "further_investigation_requested", fetch the latest FI decision
  // (the FI workflow status) so it can be shown as a badge in the list.
  useEffect(() => {
    const fiFiles = investigationFiles.filter(
      (f) => f?.status === "further_investigation_requested" && f?.id,
    );
    if (fiFiles.length === 0) {
      setFiDecisions({});
      return;
    }
    let cancelled = false;
    Promise.all(
      fiFiles.map((f) =>
        fetchFurtherInvestigationByCRNumberAndIncidentRegNo(
          f?.crime_reference_number ?? "",
          f?.incident_registration_number ?? "",
        )
          .then((reqs) => {
            const latest = (reqs || [])
              .slice()
              .sort(
                (a, b) =>
                  new Date(b?.date_requested || "").getTime() -
                  new Date(a?.date_requested || "").getTime(),
              )[0];
            return { id: String(f?.id), decision: latest?.decision };
          })
          .catch(() => ({ id: String(f?.id), decision: undefined })),
      ),
    ).then((results) => {
      if (cancelled) return;
      const map: Record<string, string> = {};
      results.forEach((r) => {
        if (r?.id && r?.decision) map[r.id] = r.decision as string;
      });
      setFiDecisions(map);
    });
    return () => {
      cancelled = true;
    };
  }, [investigationFiles]);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setFileTooltip(undefined);
      }
    }
    if (fileTooltip) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [fileTooltip]);

  const handleOpenForm = () => {
    setIsOpenForm(true);
  };
  const handleCloseForm = (refetch = false) => {
    setIsOpenForm(false);
    if (refetch) fetchData();
  };

  const totalPages = Math.ceil(count / ITEMS_PER_PAGE);

  return (
    <div className="max-w-screen-xl ml-1 mr-4 space-y-6">
      <PageHeader
        title={t("recieving_investigation_file_list")}
        icon={FaBriefcase}
        tabs={tabs}
        activeTab={activeTab}
        onTabClick={(tab) => {
          setActiveTab(tab);
          setCurrentPage(1);
        }}
        rightContent={
          <>
            {(loginData?.role === "Member" ||
              loginData?.is_police ||
              isCoordinator) && (
              <button
                onClick={() => {
                  setAction("Add");
                  handleOpenForm();
                }}
                className="px-5 py-2 text-sm font-semibold text-white bg-red-600 rounded hover:bg-red-700"
              >
                {t("add_investigation_file")}
              </button>
            )}
          </>
        }
      />

      <div className="max-w-screen-xl ml-1 mr-4 space-y-6">
        <div className="overflow-hidden bg-white shadow rounded-xl">
          {loading ? (
            <Loading label={t("loading_investigation_files")} />
          ) : (
            <table className="w-full text-sm border-collapse">
              <thead className="text-white bg-black">
                <tr>
                  <th colSpan={8} className="p-4" rounded-t-lg>
                    <div className="flex items-center justify-between">
                      <div className="flex items-center gap-2 text-lg font-semibold">
                        <button
                          onClick={() => navigate(-1)}
                          className="text-white hover:text-gray-300"
                          title={t("go_back")}
                        >
                          ◀️
                        </button>
                        <span>{t("investigation_file_list")}</span>
                      </div>

                      <div className="flex items-center gap-3">
                        {showStatusFilters && (
                          <select
                            value={decisionFilter}
                            onChange={(e) => {
                              setDecisionFilter(e.target.value);
                              setCurrentPage(1);
                            }}
                            className="py-2 px-3 text-sm text-black bg-gray-200 rounded-md focus:outline-none"
                            title={t("filter_by_decision", {
                              defaultValue: "Filter by prosecutor decision",
                            })}
                          >
                            {decisionFilterOptions
                              .filter((o) => !o.group)
                              .map((o) => (
                                <option key={o.key} value={o.key}>
                                  {o.label}
                                </option>
                              ))}
                            {[groupDecision, groupStatus].map((grp) => (
                              <optgroup key={grp} label={grp}>
                                {decisionFilterOptions
                                  .filter((o) => o.group === grp)
                                  .map((o) => (
                                    <option key={o.key} value={o.key}>
                                      {o.label}
                                    </option>
                                  ))}
                              </optgroup>
                            ))}
                          </select>
                        )}
                        <div className="relative w-80">
                          <span className="absolute inset-y-0 flex items-center text-gray-500 pointer-events-none left-3">
                            🔍
                          </span>
                          <input
                            type="text"
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                            placeholder={t("search")}
                            className="w-full py-2 pl-10 pr-4 text-sm text-black placeholder-gray-600 bg-gray-200 rounded-md focus:outline-none"
                          />
                        </div>
                      </div>
                    </div>
                  </th>
                </tr>
                <tr>
                  <th className="p-3 text-left">{t("crime_reference_no")}</th>
                  <th className="p-3 text-left">{t("receiving_date")}</th>
                  <th className="p-3 text-left">{t("investigation_by")}</th>
                  <th className="p-3 text-left">{t("police_station")}</th>
                  <th className="p-3 text-left">{t("status")}</th>
                  <th className="p-3 text-left" rounded-tr-lg>
                    {t("view")}
                  </th>
                </tr>
              </thead>
              <tbody>
                {investigationFiles.map((file, idx) => (
                  <tr
                    key={file?.id ?? idx}
                    className={idx % 2 === 0 ? "bg-[#F7F4F1AB]" : "bg-white"}
                  >
                    <td className="p-3 font-[500] font-[Poppins]">
                      {file.crime_reference_number}
                    </td>
                    <td className="p-3 font-[500] font-[Poppins]">
                      {DateView(file?.receiving_date)}
                    </td>
                    <td className="p-3 font-[500] font-[Poppins]">
                      {file?.investigationfileby &&
                        InvestigationFileBy[file?.investigationfileby]}
                    </td>
                    <td className="p-3 font-[500] font-[Poppins]">
                      {file?.police_station_name}
                    </td>
                    <td className="p-3 font-[500] font-[inter]">
                      <div className="flex flex-col items-start gap-1">
                        <StatusBadge status={file?.status || ""} />
                        {file?.status === "further_investigation_requested" &&
                          fiDecisions[String(file?.id)] && (
                            <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-semibold bg-purple-100 text-purple-800 border border-purple-200">
                              🔍{" "}
                              {t(
                                `further_investigation_decision_${
                                  fiDecisions[String(file?.id)]
                                }`,
                                {
                                  defaultValue:
                                    FurtherInvestigationDecision[
                                      fiDecisions[
                                        String(file?.id)
                                      ] as keyof typeof FurtherInvestigationDecision
                                    ] || fiDecisions[String(file?.id)],
                                },
                              )}
                            </span>
                          )}
                        {file?.is_re_intiated && (
                          <span
                            className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-semibold bg-blue-100 text-blue-800 border border-blue-200"
                            title={file?.re_initiation_reason || ""}
                          >
                            🔄 {t("re_initiated", { defaultValue: "Re-initiated" })}
                          </span>
                        )}
                        {file?.prosecutor_decision_status === "pending" &&
                          file?.prosecutor_decision_type &&
                          file?.prosecutor_decision_type !== "pending" && (
                            <span
                              className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-semibold bg-amber-100 text-amber-800 border border-amber-200"
                              title={t("decision_pending_approval")}
                            >
                              ⏳{" "}
                              {file?.is_case_suspended
                                ? t("case_resume_request")
                                : file?.prosecutor_decision_type === "suspend"
                                ? t("case_suspension_request")
                                : ProsecutorDecisionType[
                                    file.prosecutor_decision_type
                                  ] || file.prosecutor_decision_type}
                            </span>
                          )}
                      </div>
                    </td>
                    <td className="p-3 font-[500] font-[Poppins] flex flex-row gap-2 items-center">
                      <div
                        className="cursor-pointer"
                        onClick={() => {
                          navigate(
                            "/investigation-files/" + file?.id?.toString(),
                            {
                              state: file,
                            },
                          );
                        }}
                      >
                        {eyeIcon}
                      </div>

                      {isProsecutor &&
                        file?.status === "assigned_to_prosecutor" && (
                          <button
                            className="relative p-2 rounded hover:bg-gray-100"
                            onClick={() => {
                              setFileTooltip(undefined);
                              setSelectedFile(file);
                              setIsOpenInstituteOfCharge(true);
                            }}
                            onMouseEnter={(e) => {
                              const tooltip = document.createElement("div");
                              tooltip.innerText = t("merge");
                              tooltip.className =
                                "absolute left-full top-1/2 -translate-y-1/2 ml-2 px-2 py-1 bg-black text-white text-xs rounded z-50";
                              tooltip.setAttribute("id", "merge-tooltip");
                              e.currentTarget.appendChild(tooltip);
                            }}
                            onMouseLeave={(e) => {
                              const tooltip =
                                e.currentTarget.querySelector("#merge-tooltip");
                              if (tooltip) tooltip.remove();
                            }}
                          >
                            {actionListIcon}
                          </button>
                        )}
                    </td>
                  </tr>
                ))}
                {investigationFiles.length === 0 && (
                  <tr>
                    <td colSpan={6} className="p-4 text-center text-gray-500">
                      {t("no_investigation_file_found")}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          )}
        </div>
        {totalPages > 1 && (
          <div className="flex justify-center items-center gap-2 mt-4">
            <button
              onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
              disabled={currentPage === 1}
              className="px-3 py-1 rounded bg-gray-200 hover:bg-gray-300 disabled:opacity-50"
            >
              {t("prev")}
            </button>
            <span className="px-2">
              {t("page")} {currentPage} {t("of")} {totalPages}
            </span>
            <button
              onClick={() =>
                setCurrentPage((prev) => Math.min(prev + 1, totalPages))
              }
              disabled={currentPage === totalPages}
              className="px-3 py-1 rounded bg-gray-200 hover:bg-gray-300 disabled:opacity-50"
            >
              {t("next")}
            </button>
          </div>
        )}
      </div>

      <InvestigationFileForm
        action={action}
        investigationFile={action === "Edit" ? fileTooltip : undefined}
        isOpen={isOpenForm}
        onClose={handleCloseForm}
      />
      {isOpenInstituteOfCharge && (
        <RequestInstituteOfCharge
          file={selectedFile}
          investigationFiles={investigationFiles?.filter(
            (a) => a.status === "assigned_to_prosecutor",
          )}
          onCancel={() => {
            setIsOpenInstituteOfCharge(false);
            setFileTooltip(undefined);
          }}
          isOpen={isOpenInstituteOfCharge}
        />
      )}
      {isOpenDoubtful && selectedFile && (
        <RequestDoubtful
          file={selectedFile}
          onCancel={() => {
            setIsOpenDoubtful(false);
            setFileTooltip(undefined);
          }}
        />
      )}
      {isOpenSuspectToWitess && selectedFile && (
        <RequestSuspectToWitnessModal
          file={selectedFile}
          onCancel={() => {
            setIsOpenSuspectToWitness(false);
            setFileTooltip(undefined);
          }}
        />
      )}
      {isOpenClosed && selectedFile && (
        <CloseInvestigationFile
          file={selectedFile}
          setRefetch={() => fetchData()}
          onCancel={() => {
            setIsOpenClosed(false);
            setFileTooltip(undefined);
            setSelectedFile(undefined);
          }}
          isOpen={isOpenClosed}
        />
      )}
      {isOpenPettyOffence && selectedFile && (
        <PettyOffeneRequest
          file={selectedFile}
          setRefetch={() => fetchData()}
          onCancel={() => {
            setIsOpenPettyOffence(false);
            setFileTooltip(undefined);
            setSelectedFile(undefined);
          }}
        />
      )}
      {isOpenFurtherInvestigation && selectedFile && (
        <FurtherInvestigationForm
          isOpen={isOpenFurtherInvestigation}
          action={"Add"}
          file={selectedFile}
          furtherInvestigation={undefined}
          onClose={(refetch) => {
            setIsOpenFurtherInvestigation(false);
            if (refetch) {
              fetchData();
            }
          }}
        />
      )}
    </div>
  );
};

const StatusBadge: React.FC<{ status: string }> = ({ status }) => {
  const { t } = useTranslation();
  const getStatusColor = (status: string) => {
    const statusMap: { [key: string]: string } = {
      submitted: "bg-yellow-100 text-yellow-800 border-yellow-200",
      assigned_to_prosecutor: "bg-red-100 text-red-800 border-red-200",
      assigned_to_clerk: "bg-blue-100 text-blue-800 border-blue-200",
      forwarded_to_coordinator:
        "bg-purple-100 text-purple-800 border-purple-200",
      completed: "bg-green-100 text-green-800 border-green-200",
    };
    return statusMap[status] || "bg-gray-100 text-gray-800 border-gray-200";
  };

  return (
    <span
      className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-[Poppins] font-medium border ${getStatusColor(
        status,
      )}`}
    >
      {t(`status_${status}`, {
        defaultValue:
          InvestigationFileStatus[
            status as keyof typeof InvestigationFileStatus
          ] || status.replace(/_/g, " "),
      })}
    </span>
  );
};

export default InvestigationFileList;
